document.addEventListener('DOMContentLoaded', function() {
    const interval = setInterval(() => {
        const lastProgressPage = document.getElementById('quiz-kit-question-214026');
        if(lastProgressPage) {
            console.log("its result generation page")
            setTimeout(() => {

                document.getElementById('quiz-kit-question-next-button')?.click();
                clearInterval(interval);

            }, 1500);
        } else {
            console.log("its not result generation page")
        }
    }, 1000);
})